import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from 'src/app/services/excel.service';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-move-on-q',
  templateUrl: './move-on-q.component.html',
  styleUrls: ['./move-on-q.component.css']
})
export class MoveOnQComponent implements OnInit {
  FormCutGroup: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private excelService: ExcelService,
    private spinner: NgxSpinnerService,
    private auth: Authenticationservice,
  ) {
    let userdata: any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.userlevel = userdata.userlevel;

    this.FormCutGroup = this.fb.group({
      groupcodeedit: '',
      txtSearch: '',
    });
  }
  zone = '';
  userlevel = '';

  ngOnInit(): void {

    this.Loaddata1();
    this.Loaddata3();
    this.Loadgroup()
    this.setDataSet(1);
    this.FormCutGroup.get('groupcodeedit').setValue('CT');
  }
  setTypeQ = 0;
  dataApi0 = [];
  dataApi1 = [];
  dataApi3 = [];

  Loaddata1() {
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[q_id]&w=[supzone]='" + this.zone + "'and[ckdata]=1";
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.length >= 1) {
        this.dataApi1 = (res.data);
      }
    }).catch(err => { throw (err) })
  }
  Loaddata3() {
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[q_fc]&w=[supzone]='" + this.zone + "'and[ckdata]=1";
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.length >= 1) {
        this.dataApi3 = (res.data)
      }
    }).catch(err => { throw (err) })
  }
  groupCodeS = [];
  groupCodeall = [];
  //this.groupCodeall.length

  Loadgroup() {
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=[groupcode],[groupname],[qtype],[category_docs],[h_fmcode_],[h_fmname]&f=[dbo].[v_groupCode_HM]&w=[category]='H'and[qtype]in(1,3)order by 1";
    axios.get(url).then(res => {
      this.spinner.hide();
      if (res.data.length >= 1) {
        this.groupCodeall = (res.data);
      }
    }).catch(err => { throw (err) })
  }
  setDataSet(id = 0) {
    this.setTypeQ = id;
    if (id == 1) { this.dataApi0 = this.dataApi1 }
    else if (id == 3) { this.dataApi0 = this.dataApi3 }
    if (this.groupCodeall != null) {
      this.groupCodeS = this.groupCodeall.filter((el: any) => el.qtype == id);
      //console.log('groupCodeS',this.groupCodeS);
    }
    this.FormCutGroup.reset();
  }

  LoaddataQ() {
    if (this.setTypeQ == 1) { this.Loaddata1(); }
    else if (this.setTypeQ == 3) { this.Loaddata3(); }
    setTimeout(() => {
      this.setDataSet(this.setTypeQ);
    }, 500);
  }

  q_id: number;
  oldgroup: string;
  newgroup: string;
  openeditcut(q_id: any, cutg: any) {
    $("#editcut").modal('show');
    this.q_id = q_id;
    this.oldgroup = cutg;
  }

  // แก้ไขกลุ่มและงวดตัด
  Editgroupandtime() {
    this.spinner.show()
    let groupcode = this.FormCutGroup.get('groupcodeedit').value
    let teble = ""
    let url = ""
    if (this.setTypeQ == 1) teble = "[q_id]";
    else if (this.setTypeQ == 3) teble = "[q_fc]";
    url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbQBRD].[dbo]." + teble + "&s=[groupcode]='" + groupcode + "'&w=[q_id]=" + this.q_id;
    if (confirm("ต้องการแก้ไขข้อมูล คิวที่ " + this.q_id + " เป็นกลุ่ม " + groupcode)) {
      axios.get(url).then(res => {
        this.spinner.hide();
        //console.log(response);
        if (res.data.code) {
          alert("บันทึกข้อมูลไม่สำเร็จ");
        }
        else if (res.data.rowsAffected[0] >= 1) {
          alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          this.LoaddataQ();
        }
      });
    }
    else this.spinner.hide();
    this.FormCutGroup.get('groupcodeedit').setValue('CT');
  }

  // แก้ไขกลุ่ม
  EditRegroup(id = 0) {
    this.spinner.show()
    let teble = ""
    let url = ""
    if (this.setTypeQ == 1) teble = "[q_id]";
    else if (this.setTypeQ == 3) teble = "[q_fc]";
    url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbQBRD].[dbo]." + teble + "&s=[groupcode]=[groupcodeOld]&w=[q_id]=" + id;
    if (confirm("ต้องการแก้ไขข้อมูล คิวที่ " + id + " เป็นกลุ่มเดิม")) {
      axios.get(url).then(res => {
        this.spinner.hide();
        //console.log(response);
        if (res.data.code) {
          alert("บันทึกข้อมูลไม่สำเร็จ");
        }
        else if (res.data.rowsAffected[0] >= 1) {
          alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          this.LoaddataQ();
        }
      });
    }
    else this.spinner.hide();
  }

}
